import {css} from "@panda/css";

export const navigationChevronOpenStyle = css({
    transform: "rotate(180deg)",
    transition: "transform var(--transition-duration-fast) ease"
});

export const navigationChevronClosedStyle = css({
    transform: "rotate(0deg)",
    transition: "transform var(--transition-duration-fast) ease"
});

export const navigationPreferencesCtaStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    py: "1rem",
    backgroundColor: "var(--colors-secondary)",
    borderRadius: "18rem",
    transition: "box-shadow var(--transition-duration) var(--transition-timingFunction)",
    _hover: {
        boxShadow: "var(--shadow-deep)"
    }
});

export const navigationItemActiveStyle = css({
    backgroundColor: "var(--colors-background-50)"
});

export const navigationItemHoverStyle = css({
    _hover: {
        backgroundColor: "var(--colors-background-50)"
    }
});

export const navigationLinkStyle = css({
    alignItems: "center",
    borderRadius: 1,
    boxShadow: "inset 0 0 0 1px var(--colors-gray-400)",
    display: "flex",
    gap: 1,
    p: 1.5,
    transition: "background-color var(--transition-duration) var(--transition-timingFunction)"
});
import {css} from "@panda/css";

export const navigationChevronOpenStyle = css({
    transform: "rotate(180deg)",
    transition: "transform var(--transition-duration-fast) ease"
});

export const navigationChevronClosedStyle = css({
    transform: "rotate(0deg)",
    transition: "transform var(--transition-duration-fast) ease"
});

export const navigationPreferencesCtaStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    py: "1rem",
    backgroundColor: "var(--colors-secondary)",
    borderRadius: "18rem",
    transition: "box-shadow var(--transition-duration) var(--transition-timingFunction)",
    _hover: {
        boxShadow: "var(--shadow-deep)"
    }
});

export const navigationItemActiveStyle = css({
    backgroundColor: "var(--colors-background-50)"
});

export const navigationItemHoverStyle = css({
    _hover: {
        backgroundColor: "var(--colors-background-50)"
    }
});

export const navigationLinkStyle = css({
    alignItems: "center",
    borderRadius: 1,
    boxShadow: "inset 0 0 0 1px var(--colors-gray-400)",
    display: "flex",
    gap: 1,
    p: 1.5,
    transition: "background-color var(--transition-duration) var(--transition-timingFunction)"
});
